import { Link } from "react-router-dom";
import { Ghost, Mail, ShieldCheck, Truck, RefreshCcw, Lock } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-amber-900/30 bg-[#0b0810] mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pb-12 border-b border-amber-900/20">
          {[
            { icon: Truck, t: "Livraison rapide", s: "Expédié sous 48h" },
            { icon: Lock, t: "Paiement sécurisé", s: "Cryptage SSL via Stripe" },
            { icon: RefreshCcw, t: "Retours 14 jours", s: "Satisfait ou remboursé" },
            { icon: ShieldCheck, t: "Boutique de confiance", s: "Support réactif" },
          ].map((f) => (
            <div key={f.t} className="flex items-center gap-3">
              <f.icon className="h-6 w-6 text-amber-500 shrink-0" />
              <div>
                <p className="text-sm font-bold text-stone-100">{f.t}</p>
                <p className="text-xs text-stone-500">{f.s}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 py-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <Ghost className="h-7 w-7 text-amber-500" />
              <span className="font-display text-xl font-extrabold text-stone-100">Croque-Mitaine</span>
            </div>
            <p className="text-sm text-stone-400 leading-relaxed">
              L'excellence du frisson. Déguisements, décorations et accessoires pour un Halloween inoubliable.
            </p>
          </div>

          <div>
            <h4 className="eyebrow mb-4">Boutique</h4>
            <ul className="space-y-2.5 text-sm text-stone-400">
              <li><Link to="/boutique" className="hover:text-amber-400">Tous les produits</Link></li>
              <li><Link to="/boutique?cat=Déguisements" className="hover:text-amber-400">Déguisements</Link></li>
              <li><Link to="/boutique?cat=Décorations" className="hover:text-amber-400">Décorations</Link></li>
              <li><Link to="/boutique?cat=Accessoires" className="hover:text-amber-400">Accessoires</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="eyebrow mb-4">Informations légales</h4>
            <ul className="space-y-2.5 text-sm text-stone-400">
              <li><Link to="/cgv" className="hover:text-amber-400" data-testid="footer-cgv">Conditions Générales de Vente</Link></li>
              <li><Link to="/mentions-legales" className="hover:text-amber-400" data-testid="footer-mentions">Mentions Légales</Link></li>
              <li><Link to="/confidentialite" className="hover:text-amber-400" data-testid="footer-confidentialite">Politique de Confidentialité</Link></li>
              <li><Link to="/contact" className="hover:text-amber-400" data-testid="footer-contact">Contact</Link></li>
              <li><Link to="/suivi-commande" className="hover:text-amber-400" data-testid="footer-suivi">Suivi de commande</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="eyebrow mb-4">Contact</h4>
            <a
              href="mailto:mfaby.digit@gmail.com"
              className="inline-flex items-center gap-2 text-sm text-stone-400 hover:text-amber-400"
            >
              <Mail className="h-4 w-4" /> mfaby.digit@gmail.com
            </a>
            <p className="text-xs text-stone-600 mt-4 leading-relaxed">
              Service client du lundi au vendredi, 9h–18h.
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-amber-900/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-stone-500">© 2026 Croque-Mitaine. Tous droits réservés.</p>
          <p className="text-xs text-stone-600">Paiements sécurisés par Stripe · Visa · Mastercard</p>
        </div>
      </div>
    </footer>
  );
}
